/*
 * @Author: taoyuan taoyuan@originqc.com
 * @Date: 2024-01-23 14:20:12
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2026-01-04 17:49:29
 * @FilePath: \qcloud-web-pc-4.0\src\router\routeConfig.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { lazy } from "react";
import { Navigate } from "react-router-dom";
import { IndexRouteObject, NonIndexRouteObject } from "react-router";
import {
  LazyWrapper,
  // QuantumVmRedirect,
  RequireAuth,
  ComputerServicesRedirect,
} from "./tools";
// 首屏
// import Home from "@/views/home/index";

// web 终端

const Login = lazy(() => import("@/views/Login/index"));
const VerifyAccount = lazy(() => import("@/views/Login/components/VerifyAccount"));
const Register = lazy(() => import("@/views/Login/components/Register"));
const PwdReset = lazy(() => import("@/views/Login/components/PwdReset"));


export interface ICustomerIndexRouteObject extends IndexRouteObject {
  hideFooter?: boolean; //默认展示底部导航 true-隐藏
  hideHeader?: boolean; // 默认是展示头部导航 true-隐藏
  title?: string; // 网页标题
}
export interface ICustomerNonIndexRouteObject extends NonIndexRouteObject {
  hideFooter?: boolean; //默认展示底部导航 true-隐藏
  hideHeader?: boolean; // 默认是展示头部导航 true-隐藏
  title?: string; // 网页标题 title-国际化对应的key
  children?: IRouteObject[];
}

export type IRouteObject = ICustomerIndexRouteObject | ICustomerNonIndexRouteObject;

const routeConfig: IRouteObject[] = [

  // {
  //   path: "home",
  //   children: [
  //     {
  //       index: true,
  //       title: "home",
  //       element: <Home />,
  //     },
  //   ],
  // },
  {
    path: "",
    title: "login",
    element: <Login />,
  },
  // 登录模块
  {
    path: "l",
    children: [
      {
        path: "login",
        hideFooter: true,
        title: "login",
        element: LazyWrapper({ Component: Login }),
      },
      {
        path: "verify/:flag/:sceneId",
        hideFooter: true,
        title: "verify",
        element: LazyWrapper({ Component: VerifyAccount }),
      },
      {
        path: "register",
        hideFooter: true,
        title: "register",
        element: LazyWrapper({ Component: Register }),
      },
      {
        path: "NTPASS",
        hideFooter: true,
        title: "ntpass",
        element: LazyWrapper({ Component: PwdReset }),
      },
    ],
  },
  {
    path: "*",
    title: "login",
    element: <Navigate to="/l/login" />,
  },
];

export default routeConfig;
